import React from 'react'
import AccessibilityIcon from '@mui/icons-material/Accessibility'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import useClasses from '../../../hooks/UseClasses'
import { useTranslation } from 'react-i18next'

const styles = (theme) => ({
  link: {
    margin: '1rem auto',
    display: 'block',
    color: theme.palette.text.light.color + ' !important',
    variant: 'h5',
    textDecoration: 'underline !important',
    cursor: 'pointer',
    '&:hover': {
      color: theme.palette.text.success.color + ' !important',
      textDecoration: 'none !important',
    },
    '& .MuiTypography-root': {
      color: theme.palette.text.light.color,
      '&:hover': {
        color: theme.palette.text.success.color + ' !important',
      },
    },
  },
})

const HeaderPrivacity = () => {
  const { t } = useTranslation()
  const classes = useClasses(styles)
  return (
    <>
      <IconButton
        className={classes.link}
        onClick={() =>
          window.open(window.location.protocol + '//' + window.location.host + '/assets/lopdMerchant.pdf', '_blank')
        }
        size="large">
        <AccessibilityIcon style={{ marginRight: '4px' }} fontSize={'medium'} />
        <Typography>{t('HEADER.PRIVACITY')}</Typography>
      </IconButton>
    </>
  )
}

export default HeaderPrivacity
